import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import { Button, CustomInput, Description } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useChangeUserPasswordMutation } from "../../Data/services/userApi";
import Toast, { ErrorToast } from "../../Hooks/useToast";

const ChangePasswordModal = ({
  handleEditModalClose,
  data,
  handleUpdate,
  updateLoading,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const [changePassword, { isLoading }] = useChangeUserPasswordMutation();

  const handleDataSubmission = async (record) => {
    try {
      const payload = {...record, userId: data.id}
      const response = await changePassword(payload);
      // console.log(response);
      if (response.data) {
        Toast(response?.data?.message, "success");
        handleEditModalClose();
      }

      if (response?.error?.status === 400) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }
    } catch (error) {
      // console.log(error);
      Toast(error?.response?.data?.message, "error");
    }
  };

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">Change Password</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className={cssStyles.ChangePassword}>
          <p className="text-body-tertiary">Username: {data.firstname}{" "}{data.lastname}</p>
          <Form onSubmit={handleSubmit(handleDataSubmission)}>
            <div className={cssStyles.form}>
              <Description
                text="New Password"
                classes="mt-1 mb-1 black-text"
              />
              <Controller
                control={control}
                name="new_password"
                rules={{ required: "New Password is required." }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <CustomInput
                    placeholder="New Password"
                    type="password"
                    onChange={onChange}
                  />
                )}
              />
              <Description
                text="Confirm Password"
                classes="mt-3 mb-1 black-text"
              />
              <Controller
                control={control}
                name="confirm_password"
                rules={{ required: "Confirm Password is required." }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <CustomInput
                    placeholder="Confirm Password"
                    type="password"
                    onChange={onChange}
                  />
                )}
              />

              <div className={`${cssStyles.saveButton} mt-3`}>
                <Button
                  text={
                    isLoading ? <BeatLoader size={10} /> : "Change Password"
                  }
                  classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
                    isLoading ? "bg-dark-subtle" : ""
                  }`}
                  disabled={isLoading}
                  type="submit"
                />
              </div>
            </div>
          </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ChangePasswordModal;
